export default __webpack_public_path__ + "static/12-bedbab7f17f8f55df99523d474c06d8e.jpg";